import React, { useRef, useEffect, useState } from "react";
// import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import useAuth from "../../../Services/hook/useAuth";
// import { Toaster, toast } from 'sonner';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
// import { jwtDecode } from 'jwt-decode';
// import * as Yup from "yup";
import OtpVerification from "../../otpVerification/component/OtpVerification";
import { getOtp } from "../../../Services/ApiCalling"

import "../../../../style/css/meetingForm.css";

// const loginSchema = Yup.object().shape({
//   mobile_no: Yup.string()
//     .required("Mobile number is required")
//     .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
// });

const Login = (props) => {

  const routes = all_routes;
  const navigation = useNavigate();
  const { signIn } = useAuth();
  const [load, setLoad] = useState(false);
  const [showOtp, setShowOtp] = useState(false);

  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});

  const token = localStorage.getItem("LoginToken");

  useEffect(() => {
    setShow(true); // runs only on first render
  }, []);

  const [loginForm, setLoginForm] = useState({
    mobile_no: ''
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let errorMsg = "";

    if (name === "mobile_no") {
      if (!/^\d*$/.test(value)) {
        errorMsg = "Only numbers are allowed";
      } else if (value.length > 10) {
        errorMsg = "Mobile number cannot exceed 10 digits";
      } else if (value.length < 10) {
        errorMsg = "Mobile number should be 10 digits";
      } else if (value && !/^[6-9]/.test(value)) {
        errorMsg = "Mobile number must start with 6-9";
      }
    }

    setErrors({
      ...errors,
      [name]: errorMsg
    });

    if (errorMsg) return;

    setLoginForm({ ...loginForm, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (errors.mobile_no) return;
    setLoad(true);
    const resp = await getOtp(loginForm);
    console.log("getOtpgetOtp", resp?.data);
    setLoad(false);
    if (resp?.data?.User_Exist) {
      localStorage.setItem("LoginToken", resp.data?.token);
      return navigation(routes.meetingFormView);
    } else {
      setShowOtp(true); // open OTP popup
    }

  }

  const handleVerify = async (otp) => {

    console.log("Entered OTP:", otp);
    setShowOtp(false);

    const resp = await signIn(loginForm, otp);

    console.log("rsssrsssrsss123", resp?.data);
    if (resp?.data?.token) {
      return navigation(routes.meetingFormView);
    } else {
      // return navigation(routes.login);
      toast.error(resp?.data?.message, { position: "top-center" });
    }
  };


  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block min-vh-100">
        <div className="row">
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="d-flex flex-column align-items-center justify-content-center  w-100 h-100 position-relative"
              style={{
                background: 'linear-gradient(to bottom, rgb(255, 255, 255), rgb(250, 165, 6))',
                color: 'orange',
                padding: '1rem',
              }}
            >
              <img className="w-40 h-40" src={`${process.env.PUBLIC_URL}/assets/img/sai_logo/Login_SAI_logo.png`}
                style={{
                  opacity: show ? 1 : 0,
                  transform: show ? "scale(1)" : "scale(0.7)",
                  transition: "all 1.5s ease"
                }}
              />
              <div className="position-absolute text-end"
                style={{
                  bottom: '25px', right: '25px', opacity: show ? 1 : 0,
                  transform: show ? "scale(1)" : "scale(0.8)",
                  transition: "all 1.5s ease"
                }}>
                <h6 className="d-none d-lg-block">Powered By-</h6>
                <h4 className="d-none d-lg-block">Sai Computers Ltd.</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12 ">
            <div className="row justify-content-center align-items-center min-vh-100 ">

              <div className="col-md-7 mx-auto rounded-4 shadow p-4 " style={{
                width: "554px", height: "500px", bottom: '25px', right: '25px', opacity: show ? 1 : 0,
                transform: show ? "scale(1)" : "scale(0.7)",
                transition: "all 1.5s ease"
              }}>
                <form onSubmit={handleSubmit} className="">

                  <div className="d-flex flex-column align-items-center ">

                    <div className="mx-auto mb-5 text-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/sai_logo/SAI_logo_Png_1.png`}
                        style={{ width: 150, height: "auto" }}
                      />
                    </div>

                    <div className="w-100">

                      <div className="text-center mb-4">
                        <h2 className="mb-2">Sign In</h2>
                        <p className="mb-0">
                          Please enter your mobile number to sign in
                        </p>
                      </div>

                      <div className="mb-4">
                        <label className="form-label">Mobile Number</label>
                        <div className={`input-group ${errors.mobile_no ? "border border-danger" : ""}`}>
                          <input
                            type="text"
                            className="form-control border-end-0"
                            name="mobile_no"
                            placeholder="Mobile Number"
                            required
                            onChange={handleInputChange}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-device-mobile" />
                          </span>
                        </div>
                        {errors.mobile_no && (
                          <p >{errors?.mobile_no} </p>
                        )}
                      </div>

                      <div className="mb-3">
                        <button
                          // style={{
                          //   background: "linear-gradient(to bottom, rgb(248, 231, 186), rgb(250, 165, 6))",
                          //   border: "none",
                          // }}
                          type="submit"
                          className="btn w-100 meeting-submit-btn"
                          disabled={load === true}
                        >
                          {load ? (
                            <>
                              Sign In
                              <i className="fas fa-spinner fa-spin ms-2" />
                            </>
                          ) : (
                            "Sign In"
                          )}
                        </button>
                      </div>

                    </div>
                  </div>

                </form>

                <OtpVerification
                  show={showOtp}
                  onClose={() => setShowOtp(false)}
                  onVerify={handleVerify}
                />

              </div>

            </div>
          </div>
        </div>
      </div>
      {/* <Toaster
        position="right-top"
        richColors // enables richer, colorful styles
        theme="light" // or 'dark' or 'system'
      /> */}
    </div>

  );
};

export default Login;
